// Exports
export default {
	"container": "container_gRE0s",
	"footer": "footer_9tGva"
};
